import classNames from 'classnames';
import { ReactNode } from 'react';

const StickyPanel = ({
  name = 'stickyPanel',
  show = true,
  mobileOnly = true,
  children,
}: {
  name?: string;
  show?: boolean;
  mobileOnly?: boolean;
  children?: ReactNode;
}) => {
  const classes = classNames({
    'sticky-panel': true,
    'sticky-panel--mobile-only': mobileOnly,
  });

  return show ? (
    <div id={name} className={classes} data-testid={name} data-cy={name}>
      <div className="sticky-panel__inner">{children}</div>
    </div>
  ) : null;
};

export default StickyPanel;
